import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Badge from 'react-bootstrap/Badge';
import { TextButton } from '../UI/TextLink/TextLink';
import { beautifyLocalDateFromTimestamp } from '../../store/utility';

import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';

import classes from './FriendBox.css';

class FriendBox extends React.Component{

    constructor(props) {
        super(props);
        this.state = { isView: true }
        this.frequencyInput = React.createRef();
    }

    handleUpdate = () => {
        console.log(this.frequencyInput.current.value);

        let relationData;
        if (this.props.isRegisteredFriend === true) {
            relationData = {
                friends: [
                    {
                        "id": this.props.relation.id,
                        "frequency": parseInt(this.frequencyInput.current.value, 10)
                    }
                ]
            }
        }
        else {
            relationData = {
                guests: [
                    {
                        "id": this.props.relation.id,
                        "frequency": parseInt(this.frequencyInput.current.value, 10)
                    }
                ]
            }
        }

        this.props.relationSet(relationData);
        this.swapStage();
    }

    swapStage = () => {
        this.setState({isView: !this.state.isView});
    }

    render() {

        let options = (
            <Row>
            <Col>
            <Form.Label>Follow Up Frequency</Form.Label>
            <Form.Control as="select" ref={this.frequencyInput} defaultValue={this.props.relation.frequency}>
                <option key={0} value={null}>Disable</option>
                <option key={1} value={1}>1 months</option>
                <option key={2} value={2}>2 months</option>
                <option key={3} value={3}>3 months</option>
                <option key={4} value={4}>4 months</option>
                <option key={5} value={5}>5 months</option>
                <option key={6} value={6}>6 months</option>
            </Form.Control>
            </Col>
            </Row>
        )

        let changeButton = (
            <div>
                <Button variant='outline-primary' size='sm' onClick={this.swapStage}> 
                    Change
                </Button>
            </div>
        )

        let updateButton = (
            <div>
                <Button variant='outline-primary' size='sm' onClick={this.handleUpdate}> 
                    Update 
                </Button>
                <span className={classes.CancelButton}>
                    <TextButton text="cancel" callback={this.swapStage}></TextButton>
                </span>
            </div>
        )

        let settings = (
            <div className={classes.Settings}>
                {options}
            </div>
        )

        let reminderDisplay;
        if (this.props.relation.frequency === null) {
            reminderDisplay = null;
        }
        else if (this.props.relation.reminder_is_sent === false) {
            reminderDisplay = (
                <Row className={classes.Field}>
                <Col>Next Reminder</Col>
                <Col>{ beautifyLocalDateFromTimestamp(this.props.relation.next_reminder_date) }</Col>
                </Row>
            )
        }
        else if (this.props.relation.reminder_is_sent === true) {
            reminderDisplay = (
                <Row className={classes.Field}>
                <Col>Reminder Sent</Col>
                <Col>{ beautifyLocalDateFromTimestamp(this.props.relation.reminder_sent_date) }</Col>
                </Row>
            )

        }

        return (

            <div className={classes.FriendBox}>
                <Container>
                    <Row>
                        <Col md={{span:10}}>
                            {
                                (this.props.isRegisteredFriend === true) ?
                                <h5><a href={"https://www.bookmeey.com/schedule/" + this.props.relation.friend.calendar_id}>
                                    {this.props.relation.friend.first_name} {this.props.relation.friend.last_name}
                                </a></h5>
                                :
                                <h5>{this.props.relation.first_name} {this.props.relation.last_name}</h5>
                            }
                        </Col> 
                        {
                            (this.props.relation.frequency === null) ?
                            <Col md={{span:2}}><Badge variant="danger"> Inactive</Badge></Col> :
                            <Col md={{span:2}}><Badge variant="success"> Active</Badge></Col>
                        }
                    </Row>
                    <Row>
                        <Col md={{span:10}}>

                            {   this.props.relation.frequency !== null ?
                            <Row className={classes.Field}>
                                <Col>Frequency</Col>
                                <Col>{this.props.relation.frequency} months</Col>
                            </Row> 
                            : null }

                            <Row className={classes.Field}>
                                <Col>Last Talk</Col>
                                <Col>{ beautifyLocalDateFromTimestamp(this.props.relation.last_conversation_date) }</Col>
                            </Row>

                            { reminderDisplay }

                        </Col>
                        <Col md={{span:2}}> { this.state.isView === true ? changeButton : updateButton } </Col>
                    </Row>
                    { this.state.isView === true ? null : settings }
                </Container>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
    };
};

const mapDispatchToProps = dispatch => {
    return {
        relationSet: (relationData) => dispatch( actions.relationSet(relationData) ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (FriendBox);


// WEBPACK FOOTER //
// ./src/components/FriendBox/FriendBox.js